<template>
  <div />
</template>

<script>
export default {
  name: 'Empty',
  data () {
    return {
    }
  }
}
</script>

<style>

</style>
